import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-63c1ea8a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  key: 0,
  class: "content-title"
};
const _hoisted_4 = {
  class: "emoji-wrap"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "人类和身体", -1));
const _hoisted_7 = {
  class: "emoji-wrap"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "动物与自然", -1));
const _hoisted_10 = {
  class: "emoji-wrap"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "食物和饮料", -1));
const _hoisted_13 = {
  class: "emoji-wrap"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "活动", -1));
const _hoisted_16 = {
  class: "emoji-wrap"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "旅行和地点", -1));
const _hoisted_19 = {
  class: "emoji-wrap"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "物品", -1));
const _hoisted_22 = {
  class: "emoji-wrap"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "符号", -1));
const _hoisted_25 = {
  class: "emoji-wrap"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "旗帜", -1));
const _hoisted_28 = {
  class: "emoji-wrap"
};
const _hoisted_29 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    style: {
      "width": "300px"
    },
    modelValue: _ctx.activeName,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.activeName = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "emoji",
      name: "second"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_ctx.useList.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, "常用")) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useList, (item, i) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: 'use' + i
        }, [_createElementVNode("span", {
          class: "item-icon-list",
          onClick: $event => _ctx.iconSelect(item)
        }, _toDisplayString(item), 9, _hoisted_5)]);
      }), 128))]), _hoisted_6, _createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menList, (item, i) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: 'men' + i
        }, [_createElementVNode("span", {
          class: "item-icon-list",
          onClick: $event => _ctx.iconSelect(item)
        }, _toDisplayString(item), 9, _hoisted_8)]);
      }), 128))]), _hoisted_9, _createElementVNode("ul", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.animalList, (item, i) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: 'animal_list' + i
        }, [_createElementVNode("span", {
          class: "item-icon-list",
          onClick: $event => _ctx.iconSelect(item)
        }, _toDisplayString(item), 9, _hoisted_11)]);
      }), 128))]), _hoisted_12, _createElementVNode("ul", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foodList, (item, i) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: 'food_list' + i
        }, [_createElementVNode("span", {
          class: "item-icon-list",
          onClick: $event => _ctx.iconSelect(item)
        }, _toDisplayString(item), 9, _hoisted_14)]);
      }), 128))]), _hoisted_15, _createElementVNode("ul", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeList, (item, i) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: 'active_list' + i
        }, [_createElementVNode("span", {
          class: "item-icon-list",
          onClick: $event => _ctx.iconSelect(item)
        }, _toDisplayString(item), 9, _hoisted_17)]);
      }), 128))]), _hoisted_18, _createElementVNode("ul", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.potList, (item, i) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: 'pot_list' + i
        }, [_createElementVNode("span", {
          class: "item-icon-list",
          onClick: $event => _ctx.iconSelect(item)
        }, _toDisplayString(item), 9, _hoisted_20)]);
      }), 128))]), _hoisted_21, _createElementVNode("ul", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objList, (item, i) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: 'obj_list' + i
        }, [_createElementVNode("span", {
          class: "item-icon-list",
          onClick: $event => _ctx.iconSelect(item)
        }, _toDisplayString(item), 9, _hoisted_23)]);
      }), 128))]), _hoisted_24, _createElementVNode("ul", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signalList, (item, i) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: 'signal_list' + i
        }, [_createElementVNode("span", {
          class: "item-icon-list",
          onClick: $event => _ctx.iconSelect(item)
        }, _toDisplayString(item), 9, _hoisted_26)]);
      }), 128))]), _hoisted_27, _createElementVNode("ul", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flagList, (item, i) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: 'flag_list' + i
        }, [_createElementVNode("span", {
          class: "item-icon-list",
          onClick: $event => _ctx.iconSelect(item)
        }, _toDisplayString(item), 9, _hoisted_29)]);
      }), 128))])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]);
}